// @flow

export const TRACK_DATA_SOURCE = {
  USGSA: "USGSA",
  SRW: "SRW",
  RAS: "RAS"
};

export const FREE_PICK_SOURCE = {
  USGSA: "timeform",
  DEFAULT: "handicapping"
};

export const isUSGSA = (trackDataSource: string): boolean =>
  TRACK_DATA_SOURCE.USGSA === trackDataSource;

export const isSRW = (trackDataSource: string): boolean =>
  TRACK_DATA_SOURCE.SRW === trackDataSource;

export const isRAS = (trackDataSource: string): boolean =>
  TRACK_DATA_SOURCE.RAS === trackDataSource;

export const getFreePickSource = (trackDataSource: string): string => {
  if (isUSGSA(trackDataSource)) {
    return FREE_PICK_SOURCE.USGSA;
  }

  return FREE_PICK_SOURCE.DEFAULT;
};
